import {
  CANCEL_APPLICATION_SUCCESS
} from '@stores/mutation-types';
import {
  MissionApplication
} from '@services/App/missionApplication';

const state = () => ({
  responses: {
    cancel: null
  }
});

const mutations = {
  [CANCEL_APPLICATION_SUCCESS]: (state, payload) => {
    state.responses.cancel = payload;
  }
};

const actions = {
  /**
   * cancel application
   *
   * @param {object} context Vuex context keys
   * @param {string} parameters
   *
   * @return {promise}
   */
  async cancelApplication({ commit, state }, params) {
    const response = await MissionApplication.cancelApplication({
      path: {
        applicationId: params.applicationId,
        missionId: params.missionId
      },
      data: {
        team_id: params.teamId
      }
    });

    commit(CANCEL_APPLICATION_SUCCESS, response);

    return response;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
